import corporateCenterIndexPc from "./fragments/corporate-center-index-pc/en";
import corporateCenterPortal from "./fragments/corporate-center-portal/en";
import corporateCenterJoinM from "./fragments/corporate-center-join-m/en";
import corporateCenterJoinPc from "./fragments/corporate-center-join-pc/en";
import mentorJoinIndexPc from "./fragments/mentor-join-index-pc/en";

import mentorJoinJoinPc from "./fragments/mentor-join-join-pc/en";
import mentorJoinRecordingGuide from "./fragments/mentor-join-recording-guide/en";
import mHeader from "./fragments/m-header/en";
import index from "./fragments/index/en";
import common from "./fragments/common/en";
import serviceInstitutionPc from "./fragments/service-institution-pc/en";
import userPc from "./fragments/user-pc/en";
import square from "./fragments/square/en";
import aboutUs from "./fragments/aboutus/en";
import tests from "./fragments/tests/en";
import masterFortune from "./fragments/master-fortune/en";
import chat from "./fragments/chat/en";
import teacherDetailPc from "./fragments/teacher-detail-pc/en";
import creator from "./fragments/creator/en";
import tools from "./fragments/tools/en";

export default {
	index,
	common,
	square,
	corporateCenter: {
		indexPc: corporateCenterIndexPc,
		...corporateCenterPortal,
		joinM: corporateCenterJoinM,
		joinPc: corporateCenterJoinPc,
	},
	mentorJoin: {
		indexPc: mentorJoinIndexPc,
		joinPc: mentorJoinJoinPc,
		recordingGuide: mentorJoinRecordingGuide,
	},
	mHeader,
	serviceInstitution: {
		pc: serviceInstitutionPc,
	},
	user: {
		pc: userPc,
	},
	aboutUs,
	tests,
	masterFortune,
	chat,
	teacherDetail: {
		pc: teacherDetailPc,
	},
	creator,
	tools,
};
